// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const komala: PokeData = {
  "id": 775,
  "name": "komala",
  "height": 4,
  "weight": 199,
  "base_experience": 168,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "slam",
    "thrash",
    "defense-curl",
    "flail",
    "rollout",
    "rapid-spin",
    "psych-up",
    "stockpile",
    "spit-up",
    "swallow",
    "yawn",
    "sucker-punch",
    "wood-hammer"
  ],
  "moves": [
    "wood-hammer",
    "body-slam",
    "supersonic",
    "splash",
    "refresh",
    "tackle",
    "quick-attack",
    "growl",
    "protect",
    "tri-attack",
    "leer",
    "headbutt",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 401,
    "item": null,
    "species": [
      {
        "name": "komala",
        "order": 775,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 115,
    "speed": 103,
    "ability_power": 182
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
